import { baseRequestWithHeaders, rootRequestWithHeaders } from './base-request';

export const getOnboardingRequests = (params) => {
  const url = `doctors/onboarding-request`;
  const method = 'get';
  return baseRequestWithHeaders(url, method, params, null);
};
export const getOnboardingRequestIds = (params) => {
  const url = `doctors/onboarding-requestId`;
  const method = 'get';
  return baseRequestWithHeaders(url, method, params, null);
};
export const claimOnboardingRequest = (body) => {
  const url = `operator/claim/onboarding-request`;
  const method = 'POST';
  return baseRequestWithHeaders(url, method, null, body);
};

export const updateStatusOnboardingRequest = (body) => {
  const url = `operator/status/onboarding-request`;
  const method = 'POST';
  return baseRequestWithHeaders(url, method, null, body);
};

export const getCommentForRequest = (params) => {
  const url = `comments/onboarding-request`;
  const method = 'get';
  return baseRequestWithHeaders(url, method, params, null);
};
export const addCommentForRequest = (body) => {
  const url = `comments/onboarding-request`;
  const method = 'POST';
  return baseRequestWithHeaders(url, method, null, body);
};

export const initiateOnboardingVoiceCall = (body) => {
  const url = `initiate-call`;
  const method = 'POST';
  return baseRequestWithHeaders(url, method, null, body);
};

export const fetchVerticals = () => {
  const url = `operator/fetch-verticals`;
  const method = 'POST';
  return baseRequestWithHeaders(url, method, null, null);
};

export const addAssociateDoctor = (body) => {
  const url = `operator/associate-doctor`;
  const method = 'POST';
  return baseRequestWithHeaders(url, method, null, body);
};

export const createNetworkDashboardUser = (body) => {
  const url = `create-user`;
  const method = 'POST';
  return baseRequestWithHeaders(url, method, null, body);
};

export const createNewRequest  = (body) => {
  const url = `/care/onboarding-request-via-dashboard`;
  const method = 'POST';
  return rootRequestWithHeaders(url, method, null, body);
};

export const fetchDoctorVerticals = () => {
  const url = `doctors/verticals`;
  const method = 'GET';
  return baseRequestWithHeaders(url, method, null, null);

};




